import React from "react";
import { Button, makeStyles, shorthands } from "@fluentui/react-components";
import { useNavigate } from "react-router";
import { useAuth } from "../context/AuthContext";

const useStyles = makeStyles({
  page: {
    minHeight: "70vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  card: {
    width: "100%",
    maxWidth: "680px",
    backgroundColor: "#fff",
    ...shorthands.padding("28px"),
    ...shorthands.borderRadius("12px"),
    ...shorthands.border("1px", "solid", "#E6E6E6"),
    textAlign: "center",
  },
  title: {
    margin: 0,
    marginBottom: "10px",
    color: "#361936",
    fontFamily: "'Playfair Display', serif",
    fontSize: "30px",
    lineHeight: 1.2,
  },
  subtitle: {
    margin: 0,
    marginBottom: "8px",
    color: "#4A4450",
    fontFamily: "'Barlow', sans-serif",
    fontSize: "16px",
  },
  hint: {
    margin: 0,
    marginBottom: "22px",
    color: "#7A7480",
    fontFamily: "'Barlow', sans-serif",
    fontSize: "14px",
  },
  actions: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
});

const PendingApprovalPage: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate("/login", { replace: true });
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>Wartet auf Freigabe</h1>
        <p className={styles.subtitle}>
          Dein Zugang wartet auf Freigabe durch einen Admin.
        </p>
        <p className={styles.hint}>
          Sobald dein Konto aktiviert wurde, kannst du diese Seite neu laden
          und wirst zum Dashboard weitergeleitet.
        </p>
        <div className={styles.actions}>
          <Button
            appearance="primary"
            style={{
              minWidth: "180px",
              backgroundColor: "#F8AA00",
              color: "#361936",
              fontFamily: "'Barlow', sans-serif",
              fontWeight: 700,
            }}
            onClick={() => window.location.reload()}
          >
            Neu laden
          </Button>
          <Button
            appearance="secondary"
            style={{
              minWidth: "180px",
              fontFamily: "'Barlow', sans-serif",
              fontWeight: 600,
            }}
            onClick={handleSignOut}
          >
            Abmelden
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
